import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DashboardDaoService {

  private BASE_URL = environment.apiURL;
  private OPTIONS = {
    headers: new HttpHeaders({
      'Content-Type':  'application/json; charset=UTF-8'
    })
  };

  constructor( private http: HttpClient ) { }

  public getCenters(context, lang, udid) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    return this.http.get(this.BASE_URL + 'private/v2.0/dashboard/centerDevice/center', options);
  }

  public getCenterDevicesByStatus(context, lang, udid) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    return this.http.get(this.BASE_URL + 'private/v2.0/dashboard/centerDevice/devices/byStatus', options);
  }

  public getBroadcastActivity(context, lang, udid, datetimeFrom, datetimeTo, centerInternalIds) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const items = { datetimeFrom, datetimeTo, centerInternalIds };
    options['params'] = items;
    return this.http.get(this.BASE_URL + 'private/v2.0/dashboard/broadcasting/activity', options);
  }

  public getBroadcastActivityDetails(context, lang, udid, datetimeFrom, datetimeTo, centerInternalIds) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const items = { datetimeFrom, datetimeTo, centerInternalIds };
    options['params'] = items;
    return this.http.get(this.BASE_URL + 'private/v2.0/dashboard/broadcasting/activity/details', options);
  }

  public getSalesByCenter(fechaIni, fechaFin, lang, authorization) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('Authorization', authorization);
    const item = { fechaIni, fechaFin };
    return this.http.post('https://backend-market.evoratec.com/api/ver-ventas', item, options);
  }

}
